import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

import "../../index.css";
import {
  FiHome,
  FiChevronRight,
  FiSearch,
  FiUsers,
  FiGrid,
  FiFilter,
  FiFileText,
} from "react-icons/fi";
import "../Admin/SalaryManagement.css";
const Salarymanagementhr = () => {
  const { password, username } = billpunchbasicauth;
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [department, setDepartment] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(100);

  const paginationOptions = [
    { label: "100", value: 100 },
    { label: "150", value: 150 },
    { label: "250", value: 250 },
    { label: "500", value: 500 },
  ];

  const getDepartmentList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({ firmid: user.firm_id });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployeeDepartment`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setDepartmentData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  const getEmployeeList = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        firmId: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/getEmployee`,
        requestOptions,
      );
      const data = await res.json();
      if (data.status === "0") {
        setData(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    getEmployeeList();
    getDepartmentList();
  }, []);

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = data
    .filter((item) => {
      if (department === "") {
        return true;
      } else {
        return item.department === department;
      }
    })
    .filter((item) => {
      const fullName =
        `${item.firstname} ${item.lastname} ${item.empcode} ${item.designation} ${item.mobile} ${item.emptype} ${item.department}`.toLowerCase();
      return !searchQuery || fullName.includes(searchQuery.toLowerCase());
    });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const handleItemsPerPageChange = (selectedOption) => {
    setItemsPerPage(selectedOption.value);
    setCurrentPage(1); // Reset to first page when changing items per page
  };

  // Options for react-select dropdown
  const selectOptions = paginationOptions.map((option) => ({
    value: option.value,
    label: option.label,
  }));

  const departmentCount = new Set(
    data.map((employee) => employee.department).filter(Boolean),
  ).size;
  return (
    <div className="salary-management mt-3">
      <header className="salary-heading">
        <h1>Salary Management</h1>
        <div className="salary-filters">
          <div className="salary-search">
            <FiSearch />
            <input
              aria-label="Search employees"
              placeholder="Search name, code, designation…"
              value={searchQuery}
              onChange={handleSearchInputChange}
            />
          </div>
          <select
            aria-label="Department"
            value={department}
            onChange={(e) => {
              setDepartment(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Departments</option>
            {departmentData.map((dept) => (
              <option key={dept.id} value={dept.cat1}>
                {dept.cat1}
              </option>
            ))}
          </select>
          <button
            onClick={() => {
              setSearchQuery("");
              setDepartment("");
              setCurrentPage(1);
            }}
          >
            Reset
          </button>
        </div>
      </header>

      <section className="salary-list-card">
        <div className="salary-table-scroll">
          <table className="salary-table">
            <thead>
              <tr>
                {[
                  "Employee",
                  "Employee Code",
                  "Designation",
                  "Department",
                  "Mobile",
                  "Salary Details",
                ].map((label) => (
                  <th key={label}>{label}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.map((item, index) => (
                <tr key={item.empid || item.id}>
                  <td>
                    <div className="salary-employee">
                      {item.image_url ? (
                        <img
                          src={item.image_url}
                          alt={`${item.firstname} ${item.lastname}`}
                        />
                      ) : (
                        <span className="salary-avatar">
                          {item.firstname?.[0]}
                          {item.lastname?.[0]}
                        </span>
                      )}
                      <div>
                        <strong>
                          {item.firstname} {item.lastname}
                        </strong>
                        <small>{item.workemail || item.email}</small>
                      </div>
                    </div>
                  </td>
                  <td>{item.empcode || "—"}</td>
                  <td>{item.designation || "—"}</td>
                  <td>
                    <span className="salary-department">
                      {item.department || "Unassigned"}
                    </span>
                  </td>
                  <td>{item.mobile || "—"}</td>
                  <td>
                    <Link
                      className="salary-view"
                      to="/Hr/Salary-data"
                      onClick={() => {
                        sessionStorage.setItem("currentEmpId", item.empid);
                        sessionStorage.setItem(
                          "currentempname",
                          `${item.firstname} ${item.lastname}`,
                        );
                      }}
                    >
                      <FiFileText /> View Salary <FiChevronRight />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {!currentData.length && (
            <div className="salary-empty">
              No employees match the selected filters.
            </div>
          )}
        </div>
        <footer className="salary-pagination">
          <div>
            <span>Rows per page</span>
            <Select
              aria-label="Rows per page"
              classNamePrefix="salary-page-select"
              options={selectOptions}
              value={{ value: itemsPerPage, label: String(itemsPerPage) }}
              onChange={handleItemsPerPageChange}
            />
          </div>
          <div>
            <span>
              {filteredData.length ? startIndex + 1 : 0}–
              {Math.min(endIndex, filteredData.length)} of {filteredData.length}
            </span>
            <button
              disabled={currentPage <= 1}
              onClick={() => setCurrentPage((page) => page - 1)}
            >
              Previous
            </button>
            <button
              disabled={currentPage >= totalPages}
              onClick={() => setCurrentPage((page) => page + 1)}
            >
              Next
            </button>
          </div>
        </footer>
      </section>
    </div>
  );
};

export default Salarymanagementhr;
